// extracted by mini-css-extract-plugin
export default {"Text":"AuthorDisplayName-module__Text--i7M4Z","truncate":"AuthorDisplayName-module__truncate--Iw1IE"};